<label id="amount-label" *ngIf="achOnRequest"> Amount </label>
<label id="gross-net-label" *ngIf="isDetached"> Gross/Net </label>
<div [formGroup]="parentForm" [attr.class]="grossNetClass">
    <div [ngClass]="isDetached ? 'detached-control' : 'radio-container'">
        <input formControlName="amountType" [attr.name]="setName()" type="radio" id="gross" value="gross" [attr.disabled]="disableGross || null">
        <label [ngClass]="disableGross ? 'radio-label-disabled':'radio-label'" for="gross">Gross</label>
    </div>
    <div [ngClass]="isDetached ? 'detached-control' : 'radio-container'">
        <input formControlName="amountType" [attr.name]="setName()" type="radio" id="net" value="net" [attr.disabled]="disableNet || null">
        <label [ngClass]="disableNet ? 'radio-label-disabled':'radio-label'" for="net">Net</label>
    </div>
</div>
